// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";
import {Switch} from "antd";

//import styles
import '../../assets/styles/containerStyles/page-add-edit.scss';

// Import components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import MediaSelectorModal from "../../components/media/MediaSelectorModal";
import {InputGroup} from "../../components/uiElements/inputGroup";
import {LinkButton} from "../../components/buttons/buttons";
import {MediaFileCard} from "../../components/media/MediaFileCard";

// Import utils
import {
    changeStateField,
    getInputValues, getPatchReqData,
    getTranslatableInputValues,
    getTranslationData,
    initTranslations,
    toggleStateField
} from "../../utils/helperFunctions";
import {mapStateToProps} from "../../redux/mapStateToProps";
import { CreatePartner, GetPartnerById, UpdatePartnerById } from "../../redux/actions";
import {validateTranslations} from "../../utils/validateTranslations";
import {ACCEPT_IMAGE_TYPES} from "../../constants/acceptedTypes";
import {LanguageTabs} from "../../components/uiElements/Tabs";

class AddEditPartner extends Component {
    constructor(props) {
        super(props);
        this.translationsFields = [
            // 'name',
            'title',
            // 'description',
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields, props.activeLanguages),
                mediaMain: undefined,
                icon: undefined,
                link: '',
                isHidden: false,
            },
            errors: {},
            errorsTabs: [],
            isEditing: !!props?.id,
            languageTab: props.mainLanguage,
            requestLoading: false,
            mediaModalOpen: false,
            iconModalOpen: false,
        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.getPatchReqData = getPatchReqData.bind(this);
        this.toggleMediaModal = toggleStateField.bind(this, 'mediaModalOpen');
        this.toggleIconModal = toggleStateField.bind(this, 'iconModalOpen');
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getTranslationValues = getTranslatableInputValues.bind(this);

        this.getMedia = this.getMedia.bind(this);
        this.getMediaIcon = this.getMediaIcon.bind(this);
        this.addEditPartner = this.addEditPartner.bind(this);
    }

    async componentDidMount() {
        const {isEditing, fieldsData} = this.state;


        if (isEditing) {
            const translationsData = {};
            const editingData = await this.props.GetPartnerById(this.props.id)
            if (editingData) {
                editingData?.translations && Object.keys(fieldsData.translations).forEach(key => {
                    const trItem = editingData.translations.find(item => item.language === key);
                    translationsData[key] = {
                        ...fieldsData.translations[key],
                        name: trItem?.name || '',
                        title: trItem?.title || '',
                        description: trItem?.description || '',
                    };
                });
            }
            const initStateData = {
                translations: translationsData,
                link: editingData?.link || '',
                mediaMain: editingData?.mediaMain,
                icon: editingData?.icon,
                isHidden: editingData?.isHidden,
            }
            this.currentData = JSON.parse(JSON.stringify(initStateData));
            this.setState({
                ...this.state,
                fieldsData: initStateData,
            });
        }
    }

    getMedia(mediaArray) {
        const {fieldsData, errors, isEditing} = this.state;
        if (isEditing) {
            this.currentData?.mediaMain?.id !== mediaArray[0]?.id
                ? this.updatedDataMap.set('mediaMain', mediaArray[0]?.id)
                : this.updatedDataMap.delete('mediaMain');
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                mediaMain: mediaArray[0],
            },
            errors: {
                ...errors,
                mediaMain: false
            }
        })
    }

    getMediaIcon(mediaArray) {
        const {fieldsData, errors, isEditing} = this.state;
        if (isEditing) {
            this.currentData?.icon?.id !== mediaArray[0]?.id
                ? this.updatedDataMap.set('icon', mediaArray[0]?.id)
                : this.updatedDataMap.delete('icon');
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                icon: mediaArray[0],
            },
            errors: {
                ...errors,
                icon: false
            }
        })
    }

    async addEditPartner() {
        await this.setState({
            requestLoading: true
        });
        const {translations, mediaMain, icon, link, isHidden,} = this.state.fieldsData;
        const translationRequiredFields = []
        const validationTr = validateTranslations(translations, translationRequiredFields)
        let result = validationTr.result;
        const errors = {...validationTr.errors};

        if (!mediaMain) {
            errors.mediaMain = true;
            result = false;
        }
        if (!icon) {
            errors.icon = true;
            result = false;
        }
        if (result) {
            const trData = getTranslationData(translations)
            if (!this.state.isEditing) {
                const reqData = {
                    isHidden,
                    mediaMain: mediaMain.id,
                    icon: icon.id,
                    // translations: trData
                };
                link && (reqData.link = link);
                this.props.CreatePartner(reqData).finally(() => {
                    this.setState({requestLoading: false});
                })
            } else {
                const reqData = this.getPatchReqData(trData)
                this.props.UpdatePartnerById(this.props.id, reqData)
                    .finally(() => {
                        this.setState({requestLoading: false});
                    });
            }
        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }

    render() {
        const {fieldsData, errors, languageTab, mediaModalOpen, iconModalOpen, requestLoading, isEditing, errorsTabs} = this.state;
        const initData = this.currentData?.translations[languageTab] || {};
        const currentData = fieldsData.translations[languageTab] || {};

        return <PageWrapper pageTitle={!isEditing ? 'Ավելացնել Գործընկեր' : 'Փոփոխել Գործընկերոջը'}>
            <section className={`general-add-edit page-add-edit`}>
                <div className="fixed-top-right">
                    <label>{!fieldsData.isHidden ? "Ակտիվ " : "Ոչ ակտիվ "}</label>
                    <Switch checked={!fieldsData.isHidden}
                            onChange={(checked) => this.getInputValues({
                                name: "isHidden",
                                value: !checked,
                                haveChanges: this.currentData?.isHidden !== !checked
                            })}/>
                </div>
                <div className={"images-wrapper"}>
                    <div>
                        <div className="top-side">
                            <label>Նկար <span className={'required-badge'}>*</span></label>
                            <LinkButton title="Ընտրել մեդիադարանից"
                                        className={`media-select-btn ${errors.mediaMain ? 'media-select-error' : ''}`}
                                        cb={this.toggleMediaModal}
                            />
                        </div>
                        {fieldsData?.mediaMain && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.mediaMain}/>
                        </div>}
                    </div>
                    <div>
                        <div className="top-side">
                            <label> Նկար <span className={'required-badge'}>*</span></label>
                            <LinkButton title="Ընտրել մեդիադարանից"
                                        className={`media-select-btn ${errors.icon ? 'media-select-error' : ''}`}
                                        cb={this.toggleIconModal}
                            />
                        </div>
                        {fieldsData?.icon && <div className={'main-media'}>
                            <MediaFileCard item={fieldsData?.icon} />
                        </div>}
                    </div>
                </div>
                <InputGroup inputType="input"
                            type="text"
                            label="Հղում"
                            placeholder="Հղում"
                            name="link"
                            value={fieldsData?.link}
                            initValue={this.currentData?.link}
                            error={errors?.link}
                            maxLength={100}
                            onChange={this.getInputValues}/>
                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>
                <InputGroup inputType="input"
                            type="text"
                            label="Անվանում"
                            placeholder="Անվանում"
                            name="title"
                            value={currentData.title}
                            initValue={initData.title}
                            error={errors['title' + languageTab]}
                            maxLength={100}
                            required={true}
                            onChange={this.getTranslationValues}/>
{/*                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>
                <InputGroup inputType="input"
                            type="text"
                            label="Անվանում"
                            placeholder="Անվանում"
                            name="title"
                            value={currentData.title}
                            initValue={initData.title}
                            error={errors['title' + languageTab]}
                            maxLength={100}
                            required={true}
                            onChange={this.getTranslationValues}/>
                <InputGroup inputType="input"
                            type="text"
                            label="Ենթավերնագիր"
                            placeholder="Ենթավերնագիր"
                            name="name"
                            required={true}
                            value={currentData.name}
                            initValue={initData.name}
                            error={errors['name' + languageTab]}
                            maxLength={1000}
                            onChange={this.getTranslationValues}/>
                <div className="editor-wrapper">
                    <label>Նկարագրություն <span className={'required-badge'}>*</span></label>
                    <Editor value={currentData.description || ''}
                            name={'description'}
                            initValue={initData.description}
                            error={errors['description' + languageTab]}
                            onChange={this.getTranslationValues}/>
                </div>*/}
                <div className="flex-wrapper-right">
                    <LinkButton title={!isEditing ? 'Ավելացնել' : 'Փոփոխել'}
                                loading={requestLoading}
                                disabled={isEditing && !this.updatedDataMap.size}
                                cb={this.addEditPartner}/>
                </div>

            </section>
            <MediaSelectorModal
                isOpen={!!mediaModalOpen}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                getMedia={this.getMedia}
                closeModal={this.toggleMediaModal}
            />
            <MediaSelectorModal
                isOpen={!!iconModalOpen}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                getMedia={this.getMediaIcon}
                closeModal={this.toggleIconModal}/>
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetPartnerById,
    CreatePartner,
    UpdatePartnerById
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditPartner)
